export default function myImageLoader({
  src = '',
  width,
  quality,
}: {
  src: string
  width: number
  quality?: number
}) {
  return src.includes('?')
    ? `${src}&w=${width}&q=${quality || 75}`
    : `${src}?w=${width}&q=${quality || 75}`
}
